// Vue
import { ref } from 'vue'

/**
 * Estado de apertura del menu de diagnostico.
 *
 * El ref es a nivel de modulo, mismo patron que qaMode: quien DISPARA el gesto
 * (SocialMedia, dentro del drawer) no es quien RENDERIZA el dialogo (App.vue). Tienen
 * que estarlo por dos razones: SidebarDesktop monta SocialMedia dos veces, asi que un
 * dialogo interno quedaria duplicado; y el drawer se desmonta al cerrarse, llevandose
 * el dialogo con el.
 */
const open = ref(false)

export function useDiagnosticsMenu () {
  function openMenu () {
    open.value = true
  }
  function closeMenu () {
    open.value = false
  }
  return { open, openMenu, closeMenu }
}
